<template>
   <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
      <p class="menu-label">
        Production
      </p>
      <ul class="menu-list">
        <li>
          <a class="">Embroidery</a>
          <ul>
            <li v-if="task_allowed('offshore_embroidery')" @click="activeMenuLink = '/offshore/embroidery-incoming'"><router-link to="/offshore/embroidery-incoming"  :class="{'is-active':activeMenuLink === '/offshore/embroidery-incoming'}">Incoming</router-link></li>
            <li v-if="task_allowed('offshore_embroidery')" @click="activeMenuLink = '/offshore/embroidery-inprogress'" ><router-link to="/offshore/embroidery-inprogress"  :class="{'is-active':activeMenuLink === '/offshore/embroidery-inprogress'}">In Progress</router-link></li>
            <li v-if="task_allowed('offshore_embroidery_report')" @click="activeMenuLink = '/offshore/embroidery-report'" ><router-link to="/offshore/embroidery-report"  :class="{'is-active':activeMenuLink === '/offshore/embroidery-report'}">Reporting</router-link></li>
          <li v-if="task_allowed('offshore_embroidery')" @click="activeMenuLink = '/offshore/embroidery-strabane'"><router-link to="/offshore/embroidery-strabane"  :class="{'is-active':activeMenuLink === '/offshore/embroidery-strabane'}">Strabane Requests</router-link></li>
          </ul>
        </li>
        
        
      </ul>
      
    </aside>
   
   </div>
</template>

<script>
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  name: 'SideBarOffshore',
  components: {
  },
  mixins: [OrderMixin],
  data() {
    return { 
      activeMenuLink: null,
      user: {tasks: []},
     }
  },
  mounted() {
    //this.activeMenuLink = this.$route.path.substring(1)
    this.activeMenuLink = this.$route.path
    console.log(this.activeMenuLink)
  },
  created() {
		this.getAccessToken()
        .then(() => { 
           this.getUserProfile(1); // 1 for with_tasks

           
        });
	}
}

</script>



